/* Banjaaran Studio – Currency Notice (one-liner, left icon) */
(function (W, D) {
  const SEL = '[data-bj-cn]';

  function iconSvg() {
    // alert circle
    return '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 1010 10A10.012 10.012 0 0012 2zm1 13h-2v-2h2zm0-4h-2V7h2z"/></svg>';
  }

  function makeLine(cfg){
    const brand   = (cfg.brand || 'Banjaaran Studio').trim();
    const country = (cfg.country || 'India').trim();
    const cap     = (cfg.capture || 'INR');
    const disp    = (cfg.display || '');

    // one crisp sentence, inline bold on the key bits
    let line = `${brand} is a legal entity registered in <b>${country}</b>; we must accept all payments in <strong>${cap}</strong>.`;
    if (disp && disp !== cap) {
      line += ` You may see prices in <strong>${disp}</strong> for convenience; final payment is captured in <strong>${cap}</strong> at checkout.`;
    }
    if (cfg.feeNote) {
      line += ` ${cfg.feeNoteText || ''}`;
    }
    return line;
  }

  function hydrate(el){
    if (el.dataset.bjHydrated === '1') return;

    const cfg = {
      brand: el.dataset.brand,
      country: el.dataset.country,
      capture: el.dataset.capture,
      display: el.dataset.display,
      feeNote: el.dataset.feeNote === '1' || el.dataset.feeNote === 'true',
      feeNoteText: el.dataset.feeNoteText,
      variant: (el.dataset.variant || 'slim').toLowerCase(), // slim | subtle
      size: (el.dataset.size || 'sm').toLowerCase()          // xs | sm
    };

    const html = `
      <div class="bj-cn-card bj-cn--${cfg.variant} bj-cn--${cfg.size}" role="status" aria-live="polite">
        <span class="bj-cn-icon">${iconSvg()}</span>
        <span class="bj-cn-line">${makeLine(cfg)}</span>
      </div>
    `;
    el.innerHTML = html;
    el.dataset.bjHydrated = '1';
  }

  D.addEventListener('DOMContentLoaded', function(){
    D.querySelectorAll(SEL).forEach(hydrate);
  });
})(window, document);
